
import { useState, useEffect } from 'react';
import { format } from 'date-fns';

export const LiveClock = () => {
  const [time, setTime] = useState(new Date());
  
  useEffect(() => {
    // Update time every second
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    
    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, []);

  // Calculate hand rotations
  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();

  // Calculate rotations
  // Hour hand: 30 degrees per hour + 0.5 degrees per minute
  const hourRotation = hours % 12 * 30 + minutes * 0.5;
  // Minute hand: 6 degrees per minute
  const minuteRotation = minutes * 6;
  // Second hand: 6 degrees per second
  const secondRotation = seconds * 6;

  // Format current date and time
  const currentDate = format(time, 'MMMM d, yyyy');
  const currentTime = format(time, 'h:mm:ss a');
  
  return (
    <div className="flex flex-col items-center">
      {/* Clock with glowing shadow effect */}
      <div className="relative w-64 h-64 rounded-full bg-white shadow-lg border-8 border-[#0057b7] shadow-[0_0_30px_rgba(0,87,183,0.6)]">
        {/* Hour markers */}
        {[...Array(12)].map((_, i) => (
          <div 
            key={i} 
            className="absolute w-2 h-5 bg-[#0057b7] rounded-full" 
            style={{
              transform: `rotate(${i * 30}deg)`,
              transformOrigin: 'center 110px',
              left: 'calc(50% - 1px)',
              top: '10px'
            }}
          />
        ))}
        
        {/* Hour hand */}
        <div 
          className="absolute w-2.5 bg-[#0057b7] rounded-full z-[1]" 
          style={{
            height: '50px',
            left: 'calc(50% - 1.25px)',
            top: 'calc(50% - 50px)',
            transformOrigin: 'center bottom',
            transform: `rotate(${hourRotation}deg)`
          }} 
        />
        
        {/* Minute hand */}
        <div 
          className="absolute w-1.5 bg-[#0057b7] rounded-full z-[2]" 
          style={{
            height: '70px',
            left: 'calc(50% - 0.75px)',
            top: 'calc(50% - 70px)',
            transformOrigin: 'center bottom',
            transform: `rotate(${minuteRotation}deg)`
          }} 
        />
        
        {/* Second hand - visible but thin */}
        <div 
          className="absolute w-1 bg-[#0057b7] rounded-full z-[3]" 
          style={{
            height: '80px',
            left: 'calc(50% - 0.5px)',
            top: 'calc(50% - 80px)',
            transformOrigin: 'center bottom',
            transform: `rotate(${secondRotation}deg)`,
            opacity: '0.7'
          }} 
        />
        
        {/* Clock center dot */}
        <div className="absolute top-1/2 left-1/2 w-4 h-4 rounded-full bg-[#0057b7] -translate-x-1/2 -translate-y-1/2 z-10" />
      </div>

      {/* Current date in small text below the clock */}
      <div className="text-sm text-white mt-2 font-light">
        {currentDate}
      </div>
      
      {/* Current time in small text below the date */}
      <div className="text-sm text-white font-light">
        {currentTime}
      </div>
    </div>
  );
};
